const state = {
 reload_company_credit_finance: false,
};

const actions = {};

const mutations = {
 RELOAD_COMPANY_CREDIT_FINANCE(state, payload) {
  state.reload_company_credit_finance = payload.action;
 }
};

export default {
 state,
 actions,
 mutations
}
